import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { metadataIdFixer } from '@bibliocommons/utils-link';
import { bibJacketCoverAltText } from '@bibliocommons/utils-item';
import './SearchResultItem.scss';
import SearchResultItemContent from '../SearchResultItemContent';
import JacketCover from '@bibliocommons/shared-jacket-cover';

// These props are used in SearchResultItemContent
/* eslint-disable react/no-unused-prop-types */
const propTypes = {
  availabilityDetail:   ImmutablePropTypes.map,
  item:                 ImmutablePropTypes.map,
  itemRecommendations:  ImmutablePropTypes.map,
  catalogSearchOptions: ImmutablePropTypes.map,
  branches:             ImmutablePropTypes.list,
  currentUser:          ImmutablePropTypes.map,
  showJacketCover:      PropTypes.bool,
  showSeries:           PropTypes.bool,
  order:                PropTypes.number,
  dataResultRank:       PropTypes.number,
  dataKey:              PropTypes.string
};
/* eslint-enable react/no-unused-prop-types */

export function SearchResultItem(props) {
  const { item, showJacketCover, showSeries } = props;
  const jacketSource = item.getIn(['briefInfo', 'jacket']);
  const bibCoverAltText = bibJacketCoverAltText(item.getIn(['briefInfo', 'title']), item.getIn(['briefInfo', 'authors']));
  const jacketBlock = (
    <div className="col-md-2 visible-md visible-lg item-column">
      <a href={`/item/show/${metadataIdFixer(item.get('id'))}`} tabIndex="-1" aria-hidden="true" target="_parent" data-key="bib-image-link">
        <JacketCover src={jacketSource} format={item.getIn(['briefInfo', 'format'])} alt={bibCoverAltText} responsive />
      </a>
    </div>
  );

  const itemClass = showJacketCover ? 'col-md-10' : 'col-md-12';
  return (
    <li className="row cp-search-result-item" data-test-id="searchResultItem" style={{ order: props.order }} data-key={props.dataKey} data-result-rank={props.dataResultRank}>
      {showJacketCover ? jacketBlock : <noop />}
      <div className={`${itemClass} item-column`}>
        <SearchResultItemContent {...props} showSeries={showSeries} id={item.get('id')} showJacketCover={showJacketCover} />
      </div>
    </li>
  );
}

SearchResultItem.propTypes = propTypes;
SearchResultItem.defaultProps = {
  order: 0
};

export default SearchResultItem;



// WEBPACK FOOTER //
// ./app/components/search/SearchResultItem/SearchResultItem.jsx